<template>
    <div class="form-wrap">
        <div v-if="showContent">
            <Header :user-info="userInfo" :game-info="gameInfo" @logout="logout"></Header>
            <img class="banner" src="../../assets/images/banner.png">
            <div class="form-box">
                <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
                    <div class="part">个人信息</div>
                    <p class="form-tip"><span>*</span> 本页面信息均为必填，请务必认真填写！</p>
                    <a-form-model-item label="姓名" prop="userName">
                        <a-input v-model="form.userName" placeholder="请完整填写姓名"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="联系电话" prop="phoneNum">
                        <a-input v-model="form.phoneNum" placeholder="请填写完整的联系电话"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="性别" prop="gender">
                        <a-radio-group v-model="form.gender">
                            <a-radio value="male">男</a-radio>
                            <a-radio value="female">女</a-radio>
                        </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item label="证件号码" prop="idNum">
                        <a-input v-model="form.idNum" placeholder="请完整填写大陆身份证或护照的证件号码"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="所在区域" prop="address">
                        <a-cascader v-model="form.address" :options="areaData" :fieldNames="fieldName"
                                    placeholder="省/市/县"></a-cascader>
                    </a-form-model-item>
                    <a-form-model-item label="学校名称" prop="schoolName">
                        <a-input v-model="form.schoolName" placeholder="请完整填写学校名称"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="指导老师" prop="teacherName">
                        <a-input v-model="form.teacherName" placeholder="请完整填写指导老师姓名"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="指导老师联系电话" prop="teacherPhoneNum">
                        <a-input v-model="form.teacherPhoneNum" placeholder="请完整填写指导老师联系电话"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="赛项及组别" prop="gameTypeAndGroup">
                        <a-cascader v-model="form.gameTypeAndGroup" :options="gameTypeAndGroup"
                                    @change="gameTypeAndGroupChange"
                                    placeholder="赛项/组别"></a-cascader>
                    </a-form-model-item>
                    <a-form-model-item label="作品类别" prop="projectType">
                        <a-select labelInValue v-model="form.projectType" :options="projectType"
                                  @change="projectTypeChange" placeholder="选择作品类别"></a-select>
                    </a-form-model-item>
                    <div v-if="hasSelectInfo">
                        <div class="part">上传作品</div>
                        <div class="tip-box">
                            <p class="title">作品提交要求：</p>
                            <p>1）文件夹名称与作品名称应保持一致。</p>
                            <p>2）作品文件、作品说明文档、讲解视频（非必须）应放在同一文件夹中，并生成文件压缩包。</p>
                            <p>3）提交作品应上传文件压缩包（压缩包文件格式为.zip .rar .7z，文件总大小不超过30M）。</p>
                            <p>请参考以下示范：</p>
                            <img class="demo" src="../../assets/images/demo.png">
                        </div>
                        <a-form-model-item label="作品名称" prop="projectName">
                            <a-input v-model="form.projectName" placeholder="请完整填写作品名称"></a-input>
                        </a-form-model-item>
                        <a-form-model-item label="作品文件" prop="url">
                            <a-upload
                                    :beforeUpload="beforeFileUpload"
                                    :defaultFileList="defaultFileList"
                                    :multiple="true"
                                    :remove="handleFileRemove"
                                    @change="handleChange"
                                    :customRequest="handleCustomRequest"
                                    style="width: 60%"
                            >
                                <a href="javascript:" class="btn-upload" v-if="!defaultFileList.length && !isUploading">
                                    <img src="../../assets/images/upload-icon.png">上传文件</a>
                            </a-upload>
                            <a-input type="hidden" v-model="form.url"></a-input>
                        </a-form-model-item>
                    </div>
                    <a-form-model-item :wrapper-col="buttonWrapper">
                        <a-button type="primary" size="large" @click="submitInformation">提交</a-button>
                    </a-form-model-item>
                </a-form-model>
            </div>
        </div>
        <div class="empty-game" v-else>
            找不到正在提交作品中的比赛，请确认你的访问来源。
        </div>
        <div class="modal-wrap" v-if="showSuccessModal">
            <div class="modal-box">
                <h2>提交成功</h2>
                <p>作品信息已经成功提交，请耐心等待后续比赛结果。</p>
                <a class="go-back" href="https://spark.makex.cc/2020cybc-henan/">返回首页</a>
            </div>
        </div>
        <a-modal v-model="showConfirmModal" title="确认信息" ok-text="确认提交" cancel-text="取消" @ok="confirmSubmit">
            <p>请检查作品信息是否准确、完整，提交后将无法修改。</p>
        </a-modal>
        <div class="my-modal-wrap" v-if="showMyModal">
            <div class="my-modal">
                <div class="text">当前不在比赛时间内，无法进行作品提交，单击确定返回比赛页面</div>
                <a href="https://spark.makex.cc/2020cybc-henan/" class="btn">确定</a>
            </div>
        </div>
    </div>
</template>

<script>
    import client, {CLIENT_ENV} from '@makeblock/passport-client'
    import Vue from 'vue'
    import Header from '../../components/Header'
    import {FormModel, Input, Radio, Cascader, Select, Upload, Button, Modal, message} from 'ant-design-vue'
    import OSS from 'ali-oss'
    import areaData from '../../assets/json/area.json'

    client.env = CLIENT_ENV.TEST

    Vue.use(Modal)

    export default {
        name: 'Science',
        components: {
            Header,
            AFormModel: FormModel,
            AFormModelItem: FormModel.Item,
            AInput: Input,
            ARadio: Radio,
            ARadioGroup: Radio.Group,
            ACascader: Cascader,
            ASelect: Select,
            AUpload: Upload,
            AButton: Button,
            AModal: Modal
        },
        data() {
            return {
                apiHeaders: null,
                labelCol: {span: 6},
                wrapperCol: {span: 14},
                buttonWrapper: {span: 14, offset: 6},
                areaData,
                selectedGameType: '',
                selectedGameGroup: '',
                selectedProjectType: '',
                gameInfo: {
                    id: 0,
                    name: '',
                    synopsis: '',
                    startTime: '',
                    endTime: '',
                    deliveryEndTime: '',
                    projectLimitation: {
                        eachMaxNum: 1,
                        publishEndTime: '',
                        publishStartTime: '',
                    },
                    status: '',
                },
                form: {
                    userName: '',
                    phoneNum: '',
                    gender: '',
                    idNum: '',
                    address: [],
                    schoolName: '',
                    teacherName: '',
                    teacherPhoneNum: '',
                    gameTypeAndGroup: [],
                    projectType: [],
                    projectName: '',
                    url: '',
                    gameId: 0
                },
                rules: {
                    userName: [
                        {required: true, message: '姓名不能为空'},
                        {min: 1, max: 255, message: '姓名只能在1-255个字符之间'}
                    ],
                    phoneNum: [
                        {required: true, message: '联系电话不能为空'},
                        {min: 1, max: 255, message: '联系电话只能在1-255个字符之间'}
                    ],
                    gender: [
                        {required: true, message: '性别不能为空'}
                    ],
                    idNum: [
                        {required: true, message: '证件号码不能为空'},
                        {min: 1, max: 255, message: '证件号码格式错误'}
                    ],
                    address: [
                        {required: true, message: '所在区域不能为空'}
                    ],
                    schoolName: [
                        {required: true, message: '学校名称不能为空'},
                        {min: 1, max: 255, message: '学校名称只能在1-255个字符之间'}
                    ],
                    teacherName: [
                        {required: true, message: '指导老师姓名不能为空'},
                        {min: 1, max: 255, message: '指导老师姓名只能在1-255个字符之间'}
                    ],
                    teacherPhoneNum: [
                        {required: true, message: '指导老师联系电话不能为空'},
                        {min: 1, max: 255, message: '指导老师联系电话只能在1-255个字符之间'}
                    ],
                    gameTypeAndGroup: [
                        {required: true, message: '赛项及组别不能为空'}
                    ],
                    projectType: [
                        {required: true, message: '作品类别不能为空'}
                    ],
                    projectName: [
                        {required: true, message: '作品名称不能为空'},
                        {min: 1, max: 255, message: '作品名称只能在1-255个字符之间'}
                    ],
                    url: [
                        {required: true, message: '作品文件不能为空'}
                    ]
                },
                fieldName: {
                    label: 'name',
                    value: 'name',
                    children: 'children'
                },
                gameTypeAndGroup: [
                    {
                        label: 'Scratch赛项',
                        value: 1,
                        children: [
                            {
                                label: '小学组',
                                value: 1
                            },
                            {
                                label: '初中组',
                                value: 2
                            },
                            {
                                label: '高中组',
                                value: 3
                            }
                        ]
                    },
                    {
                        label: "Python赛项",
                        value: 2,
                        children: [
                            {
                                label: "初中组",
                                value: 2
                            },
                            {
                                label: "高中组",
                                value: 3
                            }
                        ]
                    }
                ],
                sex: null,
                projectType: [
                    {
                        label: '互动艺术',
                        value: 1
                    },
                    {
                        label: '实用工具',
                        value: 2
                    },
                    {
                        label: '科学探索',
                        value: 3
                    }
                ],
                userInfo: null,
                defaultFileList: [],
                ossClient: null,
                ossHost: '',
                filePath: '',
                showSuccessModal: false,
                hasSelectInfo: false,
                showConfirmModal: false,
                showMyModal: false,
                showContent: true,
                isUploading: false
            }
        },
        beforeCreate() {
            document.title = '2020河南省青少年机器人创意比赛（B类）'
        },
        created() {
            this.getGameInfo().then(() => {
                if (this.gameInfo.id) {
                    this.showContent = true
                    if (this.gameInfo.status === 1) { // 投稿中
                        this.getUserInfo().then(() => {
                            this.getOssToken()
                        })
                    } else {
                        this.showMyModal = true
                    }

                } else {
                    this.showContent = false
                }
            })
        },
        methods: {
            checkSelectInfo() {
                console.log(this.form.gameTypeAndGroup, this.form.projectType)
                this.hasSelectInfo = this.form.gameTypeAndGroup.length > 0 && this.form.projectType && this.form.projectType.key
                this.defaultFileList = []
            },
            gameTypeAndGroupChange(value, selectedOptions) {
                console.log(value)
                console.log(selectedOptions)
                this.checkSelectInfo()
                this.selectedGameType = selectedOptions ? selectedOptions[0].label : ''
                this.selectedGameGroup = selectedOptions ? selectedOptions[1].label : ''
            },
            projectTypeChange(value) {
                console.log(value)
                this.checkSelectInfo()
                this.selectedProjectType = value.label
            },
            getUrlParam(paraName) {
                let url = document.location.toString();
                let arrObj = url.split("?");
                if (arrObj.length > 1) {
                    let arrPara = arrObj[1].split("&");
                    let arr;
                    for (let i = 0; i < arrPara.length; i++) {
                        arr = arrPara[i].split("=");

                        if (arr != null && arr[0] == paraName) {
                            return arr[1];
                        }
                    }
                    return "";
                } else {
                    return "";
                }
            },

            async getGameInfo() {
                this.gameId = this.getUrlParam('gameId')
                this.gameId = parseInt(this.gameId)
                if (this.gameId) {
                    await this.$axios.get(`/game/v1/${this.gameId}`, {headers: this.apiHeaders}).then((resp) => {
                        if (resp.data.code === 0) {
                            this.gameInfo = resp.data.data
                        }
                    })
                }
            },
            async getUserInfo() {
                client.env = process.env.VUE_APP_PASSPORT_ENV
                if (client.token) {
                    this.utoken = client.token
                    try {
                        this.userInfo = await client.userInfo()
                        this.userInfo.utoken = client.token
                        this.apiHeaders = {
                            utoken: client.token
                        }
                    } catch (e) {
                        window.location.href = client.url
                    }
                } else {
                    window.location.href = client.url
                }
            },
            getOssToken() {
                this.$axios.get('/oss/v1/ststoken/spark', {
                    headers: {
                        utoken: this.userInfo.utoken
                    }
                }).then((resp) => {
                    console.log(resp)
                    this.ossClient = new OSS({
                        accessKeyId: resp.data.data.accessKeyId,
                        accessKeySecret: resp.data.data.accessKeySecret,
                        stsToken: resp.data.data.stsToken,
                        bucket: resp.data.data.ossConfig.bucket,
                        region: resp.data.data.ossConfig.region,
                    })
                    this.ossHost = `https://${resp.data.data.ossConfig.ossHost}`
                    this.filePath = `${resp.data.data.ossConfig.prefixDir}${this.gameInfo.id}/`
                })
            },
            beforeFileUpload(file) {
                console.log(file)
                this.form.url = 'uploading' // 避免此时判断作品文件为空
                return new Promise((resolve, reject) => {
                    if (!/\.(zip|rar|7z)$/.test(file.name)) {
                        message.error('文件格式不正确！')
                        this.form.url = ''
                        return reject(new Error('只支持上传rar,zip和7z格式的文件'))
                    }
                    const isLt30M = file.size / 1024 / 1024 < 30
                    if (!isLt30M) {
                        message.error('文件大小不得超过30M！')
                        this.form.url = ''
                        return reject(new Error('只支持上传30MB以内的文件'))
                    }
                    this.isUploading = true
                    console.info('文件正在上传中...')

                    return resolve(true)
                })
            },
            handleFileRemove(file) {
                this.defaultFileList = this.defaultFileList.filter(item => {
                    if (file.name !== item.name) return item
                })
                this.isUploading = false
                this.form.url = ''
                console.log(this.defaultFileList)
            },
            handleChange(info) {
                console.log(info)
                const file = info.file
                const status = info.file.status
                if (status === 'done') {
                    console.log('图片上传成功...')
                    const res = file.response
                    const item = {
                        uid: res.name,
                        name: file.name,
                        status: 'done',
                        url: `${this.ossHost}/${res.name}`,
                    }
                    this.defaultFileList.push(item)
                    this.form.url = item.url
                    this.isUploading = false
                } else if (status === 'error') {
                    console.log(`${info.file.name} 文件上传失败`)
                    this.isUploading = false
                    this.form.url = ''
                    this.isUploading = false
                }

            },
            handleCustomRequest(file) {
                this.ossClient.put(`${this.filePath}${this.selectedGameType}_${this.selectedGameGroup}_${this.selectedProjectType}_${this.userInfo.uid}_${file.file.name}`, file.file).then(res => {
                    file.onSuccess(res, file.file)
                })
            },

            submitInformation() {
                console.log(this.form)
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        this.showConfirmModal = true
                    } else {
                        return false
                    }
                })
                console.log(this.form)
            },

            confirmSubmit() {
                this.showConfirmModal = false
                this.$axios.post(`game/v1/quick-delivery`, {
                    userName: this.form.userName,
                    phoneNum: this.form.phoneNum,
                    gender: this.form.gender,
                    idNum: this.form.idNum,
                    province: this.form.address[0],
                    city: this.form.address[1],
                    area: this.form.address[2],
                    schoolName: this.form.schoolName,
                    teacherName: this.form.teacherName,
                    teacherPhoneNum: this.form.teacherPhoneNum,
                    gameType: this.form.gameTypeAndGroup[0],
                    gameGroup: this.form.gameTypeAndGroup[1],
                    projectType: this.form.projectType.key,
                    projectName: this.form.projectName,
                    url: this.form.url,
                    gameId: this.gameId
                }, {headers: this.apiHeaders}).then((resp) => {
                    console.log(resp)
                    if (resp.data.code === 0) {
                        this.showSuccessModal = true
                    } else {
                        message.error('提交失败，请稍后重试。')
                    }
                }).catch(error => {
                    console.log(error)
                    message.error('提交失败，请稍后重试。')
                })
            },

            async logout() {
                try {
                    await client.logout()
                    window.location.reload()
                } catch (e) {
                    console.log(e)
                    message.error('切换用户出现异常，请稍后重试。')
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .header-wrap {
        height: 60px !important;
        margin-bottom: 0 !important;
        .header {
            height: 60px !important;
            padding-left: 1000px;
            .logo {
                display: none;
            }
            .main {
                display: none;
            }
        }
    }

    .form-wrap {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        min-height: 100%;
        background: #f6f6f6;
    }

    .banner {
        width: 100%;
    }

    .form-box {
        width: 800px;
        padding: 40px 0 50px;
        margin: 0 auto;

        .form-tip {
            padding-top: 10px;
            text-align: left;
            margin-bottom: 30px;
            padding-left: 120px;
            span {
                color: #ff1a1a;
            }
        }

        .part {
            font-size: 30px;
            font-weight: bold;
            margin-bottom: 10px;
            text-align: center;
        }

        .tip-box {
            padding-left: 100px;
            margin-bottom: 25px;

            img {
                width: 440px;
            }

            p.title {
                font-size: 16px;
            }

            p {
                font-size: 14px;
            }
        }

        button {
            width: 160px;
        }

        .btn-upload {
            display: flex;
            width: 468px;
            height: 32px;
            border: 1px solid #009ef6;
            border-radius: 4px;
            align-items: center;
            justify-content: center;
            background: #fff;
            img {
                margin-right: 8px;
            }
        }
    }

    .modal-wrap {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, .4);

        .modal-box {
            width: 500px;
            height: 240px;
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -250px;
            margin-top: -120px;
            background: #fff;
            text-align: center;
            box-sizing: border-box;
            padding: 50px;
            border-radius: 8px;

            h2 {
                font-size: 24px;
                margin-bottom: 10px;
            }

            p {
                font-size: 16px;
                margin-bottom: 30px;
            }

            a.go-back {
                padding: 10px 20px;
                background: #009ef6;
                color: #fff;
                border-radius: 4px;
            }
        }
    }

    .my-modal-wrap {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .9);
        position: fixed;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        .my-modal {
            width: 500px;
            height: 230px;
            border-radius: 8px;
            background: #fff;

            .text {
                padding: 45px;
                font-size: 16px;
                text-align: left;
            }

            .btn {
                display: block;
                width: 146px;
                margin: 0 auto;
                height: 46px;
                line-height: 46px;
                font-size: 16px;
                text-align: center;
                text-decoration: none;
                border-radius: 46px;
                background: #009ef6;
                color: #fff;
            }
        }
    }

    .empty-game {
        width: 100%;
        height: 100%;
        text-align: center;
        font-size: 16px;
        color: #fff;
        position: fixed;
        left: 0;
        top: 0;
    }
</style>
